import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native"
//import NetInfo from "@react-native-community/netinfo";

import EnterCodeSatiaScreen from '../../../../satia/login/enterCode/EnterCodeSatiaScreen';
import {
    serviceActionAccount,
    serviceActionSetState,
    serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSuccess as SetResultSuccessSplashSatia
} from '../../../splash/action/ActionSplashSatiaScreen'
import * as NavigationService from "../../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import {Tools} from "../../../../../tools/Tools";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";

const mapStateToProps = (state) => ({
    results: state.reducerEnterCodeSatiaScreen.results,
    NoInternetDialog: state.reducerEnterCodeSatiaScreen.NoInternetDialog,
    isLoading: state.reducerEnterCodeSatiaScreen.isLoading,
    DataSplashScreen: state.reducerSplashSatiaScreen,
    isLoadingLogin: state.reducerLoginEnterPhoneCodeSatiaScreen.isLoading,

});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData)),
    callServiceSetUser: (user) => dispatch(serviceActionSetUser(user)),
    callServiceSetToken: (token) => dispatch(serviceActionSetToken(token)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData) => {

    dispatch(serviceActionPending());
    const formData = new FormData();
    // formData.append('_operation', params._operation);
    // formData.append('mode', params.mode);


    formData.append('type', 'sms');
    formData.append('username', params.username);
    formData.append('password', params.password);
    Tools.DeviceInfo(formData)

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Content-Type': 'application/json',
        }
    };
    /*    axios(
            {
                url: url ,
                method: typeConnection,
                params:params,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },

            }
        )*/
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
    //  axios.post(url, formData, config)
        .then(async response => {
            // console.log("response", response)

            /*  0 => ثبت نام نیست
               1=> ثبت نام شده رمز انتخاب نکرده یا فراموشی رمز عبور
              2=> ثبت نام شده رمز انتخاب کرده*/
            if (response.data.status) {
                let user = response.data.user

                global.CodeMobile = params.code
                dispatch(serviceActionSuccess(response.data))


                /**/
                await AsyngStorageClass.setAsyng(typeExport._USER, response.data.result);
                await AsyngStorageClass.setToken(user.token ? user.token : user.session)

                //  dispatch(SetResultSuccessSplashSatia(response.data));

                dispatch(serviceActionSetUser(user))
                dispatch(serviceActionSetToken(user.token ? user.token : user.session))
                /**/

                if (user.customers && user.customers.length > 1) {

                    /*  NavigationService.resetTo("ListAccountSatiaScreen", {

                          item: response.data,
                      });*/
                }
                else {
                    let account = user.customers[0];
                    await AsyngStorageClass.setAsyng("Account", account);
                    store.dispatch(serviceActionAccount(account, 0));

                    /*   try {
                           NavigationService.resetTo('SplashSatiaScreen')

                       } catch (e) {
                           NavigationService.navigatereset('SplashSatiaScreen')

                       }*/

                }

                /*       if (getState.route.params.type == 'forgot_my_password') {

                           Tools.SaveTokenUserAsyncProps(response.data.result.token, response.data.result);

                           NavigationService.navigateParams("ChangePassScreen", {forgot_my_password: true,})

                       } else {
                           switch (type) {

                               case Constants.TypegetDataEnterCodeSatiaScreen:
                                   if (response.data.success) {

                                       switch (response.data.result.status) {
                                           case "0" :
                                               NavigationService.navigateParams("InformationScreen", {
                                                   mobile: getState.route.params.mobile,
                                                   type: getState.route.params.type
                                               })

                                               break;

                                           /!* case "1":
                                                //   await AsyngStorageClass.setToken()
                                                NavigationService.navigateParams("ChangePassScreen")

                                                break;*!/

                                           case "2":
                                               Tools.SaveTokenUserAsyncProps(response.data.result.token, response.data.result)
                                               //NavigationService.resetTo("Drawer")
                                               try {

                                                   NavigationService.navigateParams(store.getState().reducerSplashSatiaScreen.STATE.type)
                                                   //    NavigationService.navigateParams('ProfileStack')
                                               } catch (e) {
                                                   NavigationService.resetTo("Drawer")
                                               }
                                               break;
                                           default:

                                       }
                                   } else {

                                       alert(response.data.error.message)
                                       dispatch(serviceActionRefresh())

                                   }

                                   break;

                               default:
                           }
                       }*/
            } else {
                dispatch(serviceActionRefresh())
                alert(response.data.message ? response.data.message : response.data.error)
            }


        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //         }
        //     }
        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData);
        } else {
            dispatch(serviceActionError("No Internet Connection"));
        }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.EnterCodeSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.EnterCodeSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.EnterCodeSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.EnterCodeSatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(EnterCodeSatiaScreen);
